module.exports = __webpack_public_path__ + "img/mt4Container1.b4b718bf.png";